'use es6';

import PropTypes from 'prop-types';
import { useContext, forwardRef } from 'react';
import styled from 'styled-components';
import SpacingWrapper from '../../atoms/SpacingWrapper';
import MessageUse from 'conversations-message-history/proptypes/MessageUse';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import { getAlignment, getAvatarWidth } from 'conversations-message-history/primary-message/operators/themeGetters';
import ThemeConfigContext from '../provider/ThemeConfigContext';
import ThemeProvider from '../provider/ThemeProvider';
import { PrimaryMessageAvatarWrapper } from './PrimaryMessageAvatar';
import ThemeContext from 'conversations-message-history/primary-message/provider/ThemeContext';
import { jsx as _jsx } from "react/jsx-runtime";
const PrimaryMessageWrapper = styled.div.withConfig({
  displayName: "PrimaryMessage__PrimaryMessageWrapper",
  componentId: "sc-1t4a09d-0"
})(["display:flex;flex-direction:column;align-items:", ";", "{width:", ";margin-left:0;margin-top:8px;}"], ({
  alignment
}) => alignment || 'flex-start', PrimaryMessageAvatarWrapper, ({
  avatarWidth
}) => avatarWidth);
const PrimaryMessage = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    className,
    positionDescriptors,
    use
  } = props;
  const themeConfig = useContext(ThemeConfigContext);
  const theme = useContext(ThemeContext);
  return children ? /*#__PURE__*/_jsx(ThemeProvider, {
    themeConfig: themeConfig,
    use: use,
    children: /*#__PURE__*/_jsx(SpacingWrapper, {
      positionDescriptors: positionDescriptors,
      className: className,
      ref: ref,
      children: /*#__PURE__*/_jsx(PrimaryMessageWrapper, {
        "data-test-id": props['data-test-id'],
        "data-debug-common-message-mismatch": props['data-debug-common-message-mismatch'],
        alignment: getAlignment(theme),
        avatarWidth: getAvatarWidth(theme),
        theme: theme,
        children: children
      })
    })
  }) : null;
});
PrimaryMessage.displayName = 'PrimaryMessage';
PrimaryMessage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  'data-debug-common-message-mismatch': PropTypes.bool,
  'data-test-id': PropTypes.string,
  positionDescriptors: PositionDescriptors,
  use: MessageUse
};
export default PrimaryMessage;